import React, {useContext, useEffect} from "react";
import {Link, Navigate} from 'react-router-dom'
import {useForm, FormProvider} from "react-hook-form";

import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';

import dayjs from 'dayjs';
import 'dayjs/locale/ro';

import * as TypeConvertor from '../../util/TypeConvertor';
import * as CustomStyles from '../../styles/CustomStyles';
import * as DataPattern from '../../constants/DataPattern';
import * as ValidationMessages from '../../constants/ValidationMessages';
import CustomSelect from '../../custom/CustomSelectComponent'
import * as SelectTypes from '../../constants/CustomSelectTypes'
import * as Consts from '../../constants/Consts';


const AuthzIscirCourseNew = (props) => {
    console.log('___AuthzIscirCourseNew Component___');

    const { setValue, register, reset, handleSubmit, formState: { errors, defaultValues } } = useForm({
        defaultValues: {
            lCourseRegistration: {
                id: props.authorization.id, 
                details: {
                    authISCIR: props.authorization.autorizatie.authISCIR,
                    employeeId: props.employee.id,
                    workSiteId: props.authorization.autorizatie.workSiteId
                }
            }
        } 
    });

    const [dateCourseValue, setDateCourseValue] = React.useState(dayjs(`${defaultValues.lCourseRegistration.details?.dateCourse}`));

    const handleSubmitCourseRegistration = (data) => {

        const course = data.lCourseRegistration;
        course.details.type = Consts.ExamType.CouponRenewal;

        console.log(JSON.stringify(course));

        props.postEmployeeCourse(course);

        // if(course.details.courseStatus === CourseRegistrationStatus.Completed) {
        //     console.log('Course completed !!!!!');
        //     openConfirmDialog(props.saveCourseRegistration, course);
        // }
        // else {
        //     props.saveCourseRegistration(course);
        //     handleClose();
        // }
    }    

    return(
        <Container maxWidth="xl" >
        <Box px={{xs: 3, sm: 7}}>

            <Stack spacing={1} sx={{marginBottom: 2}}>
                <Box>
                    <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                        <Link to={`/employees/authzs/iscir/${props.authorization.id}`}>
                            Autorizatie {TypeConvertor.getAuthzIscirName(props.authorization.autorizatie.authISCIR)}
                        </Link>
                        <Typography color="text.primary">
                            Curs nou
                        </Typography>
                    </Breadcrumbs>
                </Box>       

                <Box>
                    <h3>{props.employee.generalSection.lastName} {props.employee.generalSection.firstName} - Inregistrare curs</h3>
                </Box>
                <hr/>

                <form id='courseRegistrationForm' onSubmit={handleSubmit(handleSubmitCourseRegistration)}
                >
                    <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                        {/*row*/}
                        <Grid item xs={4}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ro'>
                                <DesktopDatePicker
                                    // disabled={!!props.disabled ? props.disabled : false}
                                    label="Data Inscriere la Curs"
                                    inputFormat={DataPattern.DATE_FORMAT_RO}
                                    format={DataPattern.DATE_FORMAT_RO}
                                    value={dateCourseValue}
                                    onChange={(newValue) => {
                                        setDateCourseValue( dayjs(newValue) );
                                        setValue('lCourseRegistration.details.dateCourse', newValue);
                                    }}
                                    renderInput={(params) => 
                                        <TextField {...params} variant="standard" 
                                            {...register('lCourseRegistration.details.dateCourse', {required: ValidationMessages.REQUITED_MESSAGE})}
                                            error={!!errors?.lCourseRegistration?.details?.dateCourse}
                                            helperText={errors?.lCourseRegistration?.details?.dateCourse ? errors.lCourseRegistration.details.dateCourse.message : null}
                                            onChange={(event) => console.log("TextField Chage: " + event.target.value)}
                                        />
                                    }
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField variant="standard" size="small" label="Furnizor Curs" fullWidth margin="dense" 
                                {...register("lCourseRegistration.details.courseProvider", {required: ValidationMessages.REQUITED_MESSAGE})} 
                                error={!!errors?.lCourseRegistration?.details?.courseProvider}
                                helperText={errors?.lCourseRegistration?.details?.courseProvider ? errors.lCourseRegistration.details.courseProvider.message : null}
                            />
                        </Grid>
                        <Grid item xs={4}>
                        </Grid>

                        {/*row*/}
                        <Grid item xs={8}>
                            <TextField
                                variant="standard" 
                                id="outlined-multiline-static"
                                label="Observatii"
                                multiline fullWidth margin="dense" 
                                rows={4}
                                {...register("lCourseRegistration.details.notes")}
                            />
                        </Grid>
                        <Grid item xs={4}>
                        </Grid>

                        {/*row*/}
                        <Grid item xs={4}>
                            <CustomSelect 
                                disabled={false}
                                selectId={'courseStatus'} 
                                selectType={SelectTypes.COURSE_REGISTRATION_STATUS} 
                                value={defaultValues.lCourseRegistration.details?.courseStatus} 
                                register={{...register('lCourseRegistration.details.courseStatus', {required: ValidationMessages.REQUITED_MESSAGE})}}
                                error={!!errors?.lCourseRegistration?.details?.courseStatus}
                                helperText={errors?.lCourseRegistration?.details?.courseStatus ? errors.lCourseRegistration.details.courseStatus.message : null}
                            />
                        </Grid>
                        <Grid item xs={8}>
                        </Grid>

                        {/*row*/}
                        <Grid item xs={12} container justifyContent="flex-end" alignItems="flex-end">
                            <Button variant="outlined" type="submit" sx={{ marginRight: 1}}>Salveaza</Button>
                        </Grid>

                    </Grid>
                </form>

            </Stack>
        </Box>
        </Container>
    );    
}

export default AuthzIscirCourseNew;